export enum TermLifeInsuranceStaticDocumentType {
  // INFORMATIONEN ZUR DATENBEARBEITUNG BEI PAX
  INFO_DATA_PROCESSING = "infoDataProcessing",
  // VEREINBARUNG ZUR KOMMUNIKATION VIA E-MAIL
  AGREEMENT_EMAIL_COMMUNICATION = "agreementEmailCommunication",
  // ALLGEMEINE BEDINGUNGEN FÜR DIE EINZEL-LEBENSVERSICHERUNG
  TERMS_GENERAL_INDIVIDUAL_LIFE_INSURANCE = "termsGeneralIndividualLifeInsurance",
  // ERGÄNZENDE BEDINGUNGEN FÜR TODESFALLVERSICHERUNGEN
  TERMS_SUPPLEMENT_TERM_LIFE_INSURANCE = "termsSupplementTermLifeInsurance",
  // ZUSATZBEDINGUNGEN FÜR DIE VERSICHERUNG VON NICHTRAUCHERN
  TERMS_NON_SMOKER = "termsNonSmoker",
  // INFORMATION FÜR DEN ELEKTRONISCHEN DIREKTVERTRIEB
  INFO_ELECTRONIC_DIRECT_SALES = "infoElectronicDirectSales",
  // PRODUKTINFORMATIONEN TODESFALLVERSICHERUNG
  INFO_TERM_LIFE_INSURANCE_PRODUCT = "infoTermLifeInsuranceProduct",
}
